import _ from 'lodash';

import HttpService from '@/services/http';
import { toQuery } from '@/utils/infrastructure';
import request from '@/utils/infrastructure/communication/request';

export async function queryCustomListData({ id, params, readPriority = false }) {
  return HttpService.getInstance().request(`/list/getData/${id}`, {
    method: 'post',
    ...params,
    readPriority,
  });
}

export async function queryExport({ id, params = {} }) {
  const { body, searchQuery } = params;
  return request.post(`/list/export/${id}`, {
    headers: { 'Content-Type': 'application/json' },
    params: {
      ...toQuery(params),
      ...(searchQuery && { searchQuery }),
    },
    data: { ...(body || {}) },
  });
}

export async function updateFavorite({ id, isFavorite }) {
  return isFavorite
    ? request.delete(`/list/favorites/${id}`, {})
    : request.post(`/list/favorites/${id}`, {});
}

export async function runListCommand({ httpMethod, data, ...params }) {
  const method = _.toLower(httpMethod) || 'post';
  const route = _.split(params.route, '/')
    .map((str) =>
      str.includes('{') || str.includes('}') ? params[str.replace('{', '').replace('}', '')] : str,
    )
    .join('/');

  return request[method](`/${route}`, {
    headers: { 'Content-Type': 'application/json' },
    data,
  });
}
